import { VkOrdHistoryResponse } from '@synapex/shared2/gateway-rest-api'

import { HISTORY_ITEM_STATUS } from '../../data'
import classes from './Table.module.scss'
import {
    TABLE_COLUMNS_LAYOUT,
    type TableReactNodeRecord,
} from './tableColumnsLayout'

export type TableRowProps = {
    data: VkOrdHistoryResponse
}
export const TableRow = ({ data }: TableRowProps) => {
    const {
        lastUpdatedAt,
        lastUpdateStatus,
        errorMessage,
        externalId,
        typeText,
    } = data

    const lastUpdatedAtDate = new Date(lastUpdatedAt)
    const date = lastUpdatedAtDate.toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    })

    const time = lastUpdatedAtDate.toLocaleString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
    })

    const statusInfo = HISTORY_ITEM_STATUS[lastUpdateStatus]

    const tableRow: TableReactNodeRecord = {
        typeText: <div className={classes.type}>{typeText}</div>,
        lastUpdate: (
            <div className={classes.lastUpdate}>
                <div>{date}</div>
                <div>{time}</div>
            </div>
        ),
        status: (
            <div className={classes.status} style={statusInfo.style}>
                {statusInfo.text}
            </div>
        ),
        description: <div className={classes.description}>{errorMessage}</div>,
        id: <div className={classes.id}>{externalId}</div>,
    }

    return (
        <tr>
            {TABLE_COLUMNS_LAYOUT.map(({ key, style, className }) => (
                <td key={key} style={style} className={className}>
                    {tableRow[key]}
                </td>
            ))}
        </tr>
    )
}
